import { colors, fontSizes, fontWeights, getSpacing, remCalc } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

export const StyledPillsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: ${getSpacing('xs')};
`;

export const StyledPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background-color: ${colors.gray4};
  border: 1px solid ${colors.gray3};
  border-radius: 100px;
  padding: 3px 10px;
  font-size: ${remCalc(fontSizes.s)};
  font-weight: ${fontWeights.semi};
  color: ${colors.gray1};
  cursor: pointer;
  line-height: 1.4;
  white-space: nowrap;

  &:hover {
    background-color: ${colors.gray3};
    border-color: ${colors.gray2};
  }
`;

export const StyledPillClose = styled.span`
  font-size: 14px;
  line-height: 1;
  color: ${colors.gray2};
`;

export const StyledClearFieldButton = styled.button`
  background: none;
  border: none;
  padding: 3px 2px;
  font-size: ${remCalc(fontSizes.s)};
  font-weight: ${fontWeights.semi};
  color: ${colors.blue};
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;

  &:hover {
    color: ${colors.black};
  }
`;

export const StyledSrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
